interface Data {
  name: string;
  email: string;
  company: string;
  payment_method: string;
  created_at: string;
  action: any;
}

interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
}

export const tableHeadData: readonly HeadCell[] = [
  {
    id: "name",
    numeric: false,
    disablePadding: true,
    label: "CUSTOMER NAME",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "EMAIL",
  },
  {
    id: "company",
    numeric: false,
    disablePadding: false,
    label: "COMPANY",
  },
  {
    id: "payment_method",
    numeric: true,
    disablePadding: false,
    label: "PAYMENT METHOD",
  },
  {
    id: "created_at",
    numeric: true,
    disablePadding: false,
    label: "CREATED DATE",
  },
  {
    id: "action",
    numeric: false,
    disablePadding: false,
    label: "ACTION",
  },
];

export const tableBodyData = [
  {
    id: 1,
    name: "Marney Bluett",
    email: "mbluett0@who.int",
    company: "Tagpad",
    payment_method: "4041598167278",
    created_at: "24/05/2021",
  },
  {
    id: 2,
    name: "Cristiano Thripp",
    email: "cthripp1@stanford.edu",
    company: "Mynte",
    payment_method: "36017339873962",
    created_at: "20/05/2021",
  },
  {
    id: 3,
    name: "Corette Hanselmann",
    email: "chanselmann2@purevolume.com",
    company: "Browseblab",
    payment_method: "3533125157720710",
    created_at: "06/04/2021",
  },
  {
    id: 4,
    name: "Chlo Pfeffle",
    email: "cpfeffle3@mashable.com",
    company: "Kwinu",
    payment_method: "3550870677119897",
    created_at: "17/03/2021",
  },
  {
    id: 5,
    name: "Base Talton",
    email: "btalton4@is.gd",
    company: "JumpXS",
    payment_method: "30151583903260",
    created_at: "27/04/2021",
  },
  {
    id: 6,
    name: "Charlotte Andreaccio",
    email: "candreaccio5@e-recht24.de",
    company: "Browsedrive",
    payment_method: "5402837189612920",
    created_at: "26/04/2021",
  },
  {
    id: 7,
    name: "Gert Orrice",
    email: "gorrice6@delicious.com",
    company: "Trupe",
    payment_method: "3543219368721373",
    created_at: "23/07/2021",
  },
  {
    id: 8,
    name: "Emmeline Sharp",
    email: "esharp7@sohu.com",
    company: "Devpoint",
    payment_method: "4041376818662",
    created_at: "09/05/2021",
  },
  {
    id: 9,
    name: "Albertine Shippey",
    email: "ashippey8@virginia.edu",
    company: "Dynazzy",
    payment_method: "5100174691767967",
    created_at: "25/06/2021",
  },
  {
    id: 10,
    name: "Umeko Abdey",
    email: "uabdey9@usa.gov",
    company: "Yotz",
    payment_method: "3567285660434644",
    created_at: "11/07/2021",
  },
  {
    id: 11,
    name: "Datha Dellenbroker",
    email: "ddellenbrokera@purevolume.com",
    company: "Flashdog",
    payment_method: "6762336652654818",
    created_at: "30/10/2020",
  },
  {
    id: 12,
    name: "Berrie Colborn",
    email: "bcolbornb@addthis.com",
    company: "Linkbridge",
    payment_method: "3572468068040238",
    created_at: "22/01/2021",
  },
  {
    id: 13,
    name: "Janeczka Pierucci",
    email: "jpieruccic@networksolutions.com",
    company: "Reallinks",
    payment_method: "3582143865410466",
    created_at: "22/05/2021",
  },
  {
    id: 14,
    name: "Angelika Jeannon",
    email: "ajeannond@woothemes.com",
    company: "Youopia",
    payment_method: "4041377745908173",
    created_at: "05/08/2021",
  },
  {
    id: 15,
    name: "Janice Sedgmond",
    email: "jsedgmonde@netscape.com",
    company: "Reallinks",
    payment_method: "4917787697535876",
    created_at: "31/10/2020",
  },
  {
    id: 16,
    name: "Gabi Gissing",
    email: "ggissingf@tinypic.com",
    company: "Edgepulse",
    payment_method: "3574249763725986",
    created_at: "22/06/2021",
  },
  {
    id: 17,
    name: "Ninon Ayliffe",
    email: "nayliffeg@yelp.com",
    company: "Fadeo",
    payment_method: "3564386419843011",
    created_at: "22/10/2020",
  },
  {
    id: 18,
    name: "Kandy Kernell",
    email: "kkernellh@php.net",
    company: "Gabtune",
    payment_method: "3534578314495569",
    created_at: "05/06/2021",
  },
  {
    id: 19,
    name: "Stefa Rogerot",
    email: "srogeroti@npr.org",
    company: "Oyoyo",
    payment_method: "3577039824749282",
    created_at: "23/07/2021",
  },
  {
    id: 20,
    name: "Kelila Mattock",
    email: "kmattockj@blogtalkradio.com",
    company: "Voonix",
    payment_method: "3574996741937154",
    created_at: "03/10/2021",
  },
  {
    id: 21,
    name: "Nissie Stienham",
    email: "nstienhamk@patch.com",
    company: "Aivee",
    payment_method: "30462682847278",
    created_at: "03/01/2021",
  },
  {
    id: 22,
    name: "Estrella Corkel",
    email: "ecorkell@mediafire.com",
    company: "Yamia",
    payment_method: "6389144355175906",
    created_at: "09/10/2021",
  },
  {
    id: 23,
    name: "Brody Pinyon",
    email: "bpinyonm@jiathis.com",
    company: "BlogXS",
    payment_method: "4405951778537602",
    created_at: "08/11/2020",
  },
  {
    id: 24,
    name: "Franni Pichan",
    email: "fpichann@techcrunch.com",
    company: "Skiptube",
    payment_method: "6761671944165837178",
    created_at: "12/06/2021",
  },
  {
    id: 25,
    name: "Ardyce Bathersby",
    email: "abathersbyo@youtube.com",
    company: "Yoveo",
    payment_method: "5412273445399136",
    created_at: "04/08/2021",
  },
  {
    id: 26,
    name: "Ginger Balderson",
    email: "gbaldersonp@netlog.com",
    company: "Zazio",
    payment_method: "5193964360612611",
    created_at: "22/02/2021",
  },
  {
    id: 27,
    name: "Marion Grafton",
    email: "mgraftonq@miibeian.gov.cn",
    company: "Cogidoo",
    payment_method: "633478064296395160",
    created_at: "23/09/2021",
  },
  {
    id: 28,
    name: "Bernelle Lowdes",
    email: "blowdesr@auda.org.au",
    company: "Gabtune",
    payment_method: "5602249639254345",
    created_at: "25/12/2020",
  },
  {
    id: 29,
    name: "Husein Menear",
    email: "hmenears@t-online.de",
    company: "Bubblemix",
    payment_method: "5602237699524749",
    created_at: "07/12/2020",
  },
  {
    id: 30,
    name: "Stephanie Franklin",
    email: "sfranklint@google.fr",
    company: "Aimbo",
    payment_method: "6396517812377770",
    created_at: "07/03/2021",
  },
  {
    id: 31,
    name: "Rickert Rawcliffe",
    email: "rrawcliffeu@discovery.com",
    company: "Tanoodle",
    payment_method: "5602224582626955079",
    created_at: "03/04/2021",
  },
  {
    id: 32,
    name: "Ann-marie Wadsworth",
    email: "awadsworthv@wsj.com",
    company: "Avamm",
    payment_method: "4913502844794639",
    created_at: "31/10/2020",
  },
  {
    id: 33,
    name: "Jeramie Stockin",
    email: "jstockinw@prnewswire.com",
    company: "Kanoodle",
    payment_method: "201437283173558",
    created_at: "10/05/2021",
  },
  {
    id: 34,
    name: "Glory Meaney",
    email: "gmeaneyx@yolasite.com",
    company: "Youfeed",
    payment_method: "4017951960475",
    created_at: "17/02/2021",
  },
  {
    id: 35,
    name: "Geoffry Larne",
    email: "glarney@comcast.net",
    company: "Abata",
    payment_method: "3548349497630958",
    created_at: "18/07/2021",
  },
  {
    id: 36,
    name: "Mitchael Sola",
    email: "msolaz@ftc.gov",
    company: "Voolith",
    payment_method: "5602252824931057",
    created_at: "20/07/2021",
  },
  {
    id: 37,
    name: "Massimo Lambertazzi",
    email: "mlambertazzi10@nature.com",
    company: "Thoughtbeat",
    payment_method: "3556455645755933",
    created_at: "06/11/2020",
  },
  {
    id: 38,
    name: "Adelle Verny",
    email: "averny11@theatlantic.com",
    company: "Yozio",
    payment_method: "5048378899077294",
    created_at: "02/08/2021",
  },
  {
    id: 39,
    name: "Melly Tirrey",
    email: "mtirrey12@liveinternet.ru",
    company: "Browsebug",
    payment_method: "5020266704913316187",
    created_at: "14/09/2021",
  },
  {
    id: 40,
    name: "Herb Dran",
    email: "hdran13@thetimes.co.uk",
    company: "Miboo",
    payment_method: "5108755978703337",
    created_at: "08/03/2021",
  },
  {
    id: 41,
    name: "Melonie Polin",
    email: "mpolin14@xing.com",
    company: "Topiclounge",
    payment_method: "56022177458581065",
    created_at: "17/07/2021",
  },
  {
    id: 42,
    name: "Arabele Vaney",
    email: "avaney15@mozilla.com",
    company: "Babbleopia",
    payment_method: "3547860737476946",
    created_at: "29/07/2021",
  },
  {
    id: 43,
    name: "Maurene Doud",
    email: "mdoud16@cdc.gov",
    company: "Kimia",
    payment_method: "3533925803334133",
    created_at: "29/12/2020",
  },
  {
    id: 44,
    name: "Ignace Tuberfield",
    email: "ituberfield17@walmart.com",
    company: "Livetube",
    payment_method: "3561883911532244",
    created_at: "03/10/2021",
  },
  {
    id: 45,
    name: "Florry Sheilds",
    email: "fsheilds18@nhs.uk",
    company: "Trilia",
    payment_method: "3561341883931282",
    created_at: "29/07/2021",
  },
  {
    id: 46,
    name: "Prisca Lingley",
    email: "plingley19@wp.com",
    company: "Edgetag",
    payment_method: "5602217081995640",
    created_at: "30/09/2021",
  },
  {
    id: 47,
    name: "Neila Latehouse",
    email: "nlatehouse1a@ibm.com",
    company: "Vidoo",
    payment_method: "4508348207862238",
    created_at: "24/04/2021",
  },
  {
    id: 48,
    name: "Vallie Bore",
    email: "vbore1b@webeden.co.uk",
    company: "Skalith",
    payment_method: "5018589191455826126",
    created_at: "05/09/2021",
  },
  {
    id: 49,
    name: "Gary Pockey",
    email: "gpockey1c@etsy.com",
    company: "Oloo",
    payment_method: "3565374232353516",
    created_at: "18/11/2020",
  },
  {
    id: 50,
    name: "Freda Maddy",
    email: "fmaddy1d@omniture.com",
    company: "Realbridge",
    payment_method: "0604619685858858400",
    created_at: "26/04/2021",
  },
  {
    id: 51,
    name: "Barbe Iannuzzi",
    email: "biannuzzi1e@soup.io",
    company: "Twimbo",
    payment_method: "677154537273213744",
    created_at: "09/02/2021",
  },
  {
    id: 52,
    name: "Rowe Towell",
    email: "rtowell1f@squarespace.com",
    company: "Devify",
    payment_method: "5100141234404291",
    created_at: "28/11/2020",
  },
  {
    id: 53,
    name: "Rory Petts",
    email: "rpetts1g@paypal.com",
    company: "Twimm",
    payment_method: "5602257076882791",
    created_at: "11/08/2021",
  },
  {
    id: 54,
    name: "Virgie Rove",
    email: "vrove1h@storify.com",
    company: "Wordtune",
    payment_method: "3530124525060993",
    created_at: "11/12/2020",
  },
  {
    id: 55,
    name: "Lurleen Menichi",
    email: "lmenichi1i@drupal.org",
    company: "Dynava",
    payment_method: "3544272224523839",
    created_at: "04/01/2021",
  },
  {
    id: 56,
    name: "Matty Gerault",
    email: "mgerault1j@vistaprint.com",
    company: "Babblestorm",
    payment_method: "3574380166867966",
    created_at: "16/11/2020",
  },
  {
    id: 57,
    name: "Dedra Kempster",
    email: "dkempster1k@cbc.ca",
    company: "Skaboo",
    payment_method: "3547874268429570",
    created_at: "14/07/2021",
  },
  {
    id: 58,
    name: "Clifford Haughan",
    email: "chaughan1l@deliciousdays.com",
    company: "Kanoodle",
    payment_method: "4041374512283",
    created_at: "21/02/2021",
  },
  {
    id: 59,
    name: "Ellynn Twitching",
    email: "etwitching1m@wikia.com",
    company: "Kare",
    payment_method: "337941192222403",
    created_at: "12/05/2021",
  },
  {
    id: 60,
    name: "Malina Villiers",
    email: "mvilliers1n@ask.com",
    company: "Yozio",
    payment_method: "3542768738759969",
    created_at: "03/03/2021",
  },
  {
    id: 61,
    name: "Neel Titterrell",
    email: "ntitterrell1o@apple.com",
    company: "Pixope",
    payment_method: "3578431869882251",
    created_at: "03/04/2021",
  },
  {
    id: 62,
    name: "Genny Shorrock",
    email: "gshorrock1p@timesonline.co.uk",
    company: "Thoughtbeat",
    payment_method: "201873002872106",
    created_at: "15/09/2021",
  },
  {
    id: 63,
    name: "Randolf Hearsey",
    email: "rhearsey1q@feedburner.com",
    company: "Twitterlist",
    payment_method: "30287294132417",
    created_at: "28/08/2021",
  },
  {
    id: 64,
    name: "Phylis Hughes",
    email: "phughes1r@umich.edu",
    company: "Twimm",
    payment_method: "3585188331843888",
    created_at: "01/02/2021",
  },
  {
    id: 65,
    name: "Salomi Mapson",
    email: "smapson1s@g.co",
    company: "Camimbo",
    payment_method: "30053455107055",
    created_at: "10/07/2021",
  },
  {
    id: 66,
    name: "Shep Chappel",
    email: "schappel1t@toplist.cz",
    company: "Twimbo",
    payment_method: "6385070854426934",
    created_at: "26/06/2021",
  },
  {
    id: 67,
    name: "Erma Woolager",
    email: "ewoolager1u@yale.edu",
    company: "Latz",
    payment_method: "30456237765928",
    created_at: "21/02/2021",
  },
  {
    id: 68,
    name: "Aileen Hadlington",
    email: "ahadlington1v@alibaba.com",
    company: "Quire",
    payment_method: "50389952605485026",
    created_at: "14/07/2021",
  },
  {
    id: 69,
    name: "Laura Birchenough",
    email: "lbirchenough1w@techcrunch.com",
    company: "Linklinks",
    payment_method: "3577523163272089",
    created_at: "13/05/2021",
  },
  {
    id: 70,
    name: "Bret Stockey",
    email: "bstockey1x@irs.gov",
    company: "Tagtune",
    payment_method: "3562590124606694",
    created_at: "07/05/2021",
  },
  {
    id: 71,
    name: "Sarge Vaughan",
    email: "svaughan1y@upenn.edu",
    company: "Photofeed",
    payment_method: "5247198109976385",
    created_at: "18/12/2020",
  },
  {
    id: 72,
    name: "Beatrice Lukovic",
    email: "blukovic1z@ameblo.jp",
    company: "Jazzy",
    payment_method: "3544522665865689",
    created_at: "09/08/2021",
  },
  {
    id: 73,
    name: "Davidson Saura",
    email: "dsaura20@amazon.de",
    company: "Skinix",
    payment_method: "5602220292165607",
    created_at: "28/03/2021",
  },
  {
    id: 74,
    name: "Rurik Spurritt",
    email: "rspurritt21@google.co.uk",
    company: "Realpoint",
    payment_method: "67590313858631304",
    created_at: "14/08/2021",
  },
  {
    id: 75,
    name: "Dyanna Dewbury",
    email: "ddewbury22@hostgator.com",
    company: "Teklist",
    payment_method: "201623126886445",
    created_at: "24/09/2021",
  },
  {
    id: 76,
    name: "Jacquetta Leebeter",
    email: "jleebeter23@google.de",
    company: "Wordify",
    payment_method: "491105727685359765",
    created_at: "02/06/2021",
  },
  {
    id: 77,
    name: "Ebba Jouen",
    email: "ejouen24@un.org",
    company: "Skivee",
    payment_method: "3585787949923485",
    created_at: "20/01/2021",
  },
  {
    id: 78,
    name: "Rafaela Hartus",
    email: "rhartus25@buzzfeed.com",
    company: "Fadeo",
    payment_method: "3559489014761443",
    created_at: "15/02/2021",
  },
  {
    id: 79,
    name: "Dory Prettejohns",
    email: "dprettejohns26@issuu.com",
    company: "Rhyzio",
    payment_method: "4041599450509",
    created_at: "22/01/2021",
  },
  {
    id: 80,
    name: "Brigitta Melan",
    email: "bmelan27@goo.gl",
    company: "Gabvine",
    payment_method: "5602237748950028",
    created_at: "17/07/2021",
  },
  {
    id: 81,
    name: "Hazel McKernan",
    email: "hmckernan28@washingtonpost.com",
    company: "Wordpedia",
    payment_method: "6761567847822260048",
    created_at: "16/03/2021",
  },
  {
    id: 82,
    name: "Zorine Staten",
    email: "zstaten29@google.co.uk",
    company: "Agimba",
    payment_method: "3554247856591962",
    created_at: "05/06/2021",
  },
  {
    id: 83,
    name: "Breena Hatto",
    email: "bhatto2a@engadget.com",
    company: "Aibox",
    payment_method: "6389411744191989",
    created_at: "19/04/2021",
  },
  {
    id: 84,
    name: "Dorian Fudger",
    email: "dfudger2b@imageshack.us",
    company: "Devpulse",
    payment_method: "4911986464553924",
    created_at: "20/06/2021",
  },
  {
    id: 85,
    name: "Charlean Beesley",
    email: "cbeesley2c@patch.com",
    company: "Yabox",
    payment_method: "5108755154301914",
    created_at: "05/06/2021",
  },
  {
    id: 86,
    name: "Brittni Bertome",
    email: "bbertome2d@linkedin.com",
    company: "Livetube",
    payment_method: "3566186897540859",
    created_at: "20/05/2021",
  },
  {
    id: 87,
    name: "Lin Craw",
    email: "lcraw2e@google.cn",
    company: "Dablist",
    payment_method: "3584185689276605",
    created_at: "24/12/2020",
  },
  {
    id: 88,
    name: "Sascha Emeney",
    email: "semeney2f@discuz.net",
    company: "Viva",
    payment_method: "5048371688838273",
    created_at: "12/07/2021",
  },
  {
    id: 89,
    name: "Myrtle Ferneley",
    email: "mferneley2g@smugmug.com",
    company: "Mymm",
    payment_method: "3537335725971333",
    created_at: "20/10/2020",
  },
  {
    id: 90,
    name: "Tybalt Brazur",
    email: "tbrazur2h@liveinternet.ru",
    company: "Eire",
    payment_method: "3574370991058311",
    created_at: "25/01/2021",
  },
  {
    id: 91,
    name: "Lanna Hedditch",
    email: "lhedditch2i@timesonline.co.uk",
    company: "Podcat",
    payment_method: "4936580644946458381",
    created_at: "13/07/2021",
  },
  {
    id: 92,
    name: "Kimmie Strotone",
    email: "kstrotone2j@live.com",
    company: "Devpoint",
    payment_method: "5602215636411725",
    created_at: "22/08/2021",
  },
  {
    id: 93,
    name: "Broderic Peizer",
    email: "bpeizer2k@multiply.com",
    company: "Avavee",
    payment_method: "6767875017781637024",
    created_at: "18/08/2021",
  },
  {
    id: 94,
    name: "Amos Cousen",
    email: "acousen2l@macromedia.com",
    company: "Quatz",
    payment_method: "493644184654527093",
    created_at: "14/05/2021",
  },
  {
    id: 95,
    name: "Huntlee Bickerton",
    email: "hbickerton2m@reference.com",
    company: "Tazz",
    payment_method: "3583276365038319",
    created_at: "13/05/2021",
  },
  {
    id: 96,
    name: "Thaine Rusbridge",
    email: "trusbridge2n@devhub.com",
    company: "Edgewire",
    payment_method: "201578387323597",
    created_at: "03/05/2021",
  },
  {
    id: 97,
    name: "Madelon Knevett",
    email: "mknevett2o@uiuc.edu",
    company: "Jetwire",
    payment_method: "5413406364113810",
    created_at: "02/12/2020",
  },
  {
    id: 98,
    name: "Mikey MacGettigen",
    email: "mmacgettigen2p@soup.io",
    company: "Jabbercube",
    payment_method: "3541281350681975",
    created_at: "13/05/2021",
  },
  {
    id: 99,
    name: "Zora Tunna",
    email: "ztunna2q@state.tx.us",
    company: "Oloo",
    payment_method: "3586710776579831",
    created_at: "30/10/2020",
  },
  {
    id: 100,
    name: "Nicko Gadson",
    email: "ngadson2r@people.com.cn",
    company: "Blognation",
    payment_method: "3539037060449218",
    created_at: "15/09/2021",
  },
];
